import { OnlineExamsComponent } from './../../statistics/online-exams/online-exams.component';
import { CookieNames, redirectionPoints } from './../../constant';
import { LocalStorageService } from 'angular-2-local-storage';
import { Component, OnInit, Input } from '@angular/core';
import { ShoppingCartService, CustomObserverService, CookieManagerService, LoginRedirectService } from '../../../shared/';
import { PaperSet } from '../../model';
import { Router } from '@angular/router';
import { SubscriptionInfoService } from '../../subscription-packages/subscription-info-service.service';
declare var $: any;

@Component({
  selector: 'app-add-cart',
  templateUrl: '../views/add-cart.component.html',
  styleUrls: ['../../../css/home.component.css']
})
export class AddCartComponent implements OnInit {

  @Input() paperSet: PaperSet;
  @Input() id: string;
  @Input() isShowing: boolean;
  @Input() cannotBuy: boolean;
  cartItemsIDArray: string[];
  click: boolean;
  public currentPaymentType: string;

  constructor(
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private customObserverService: CustomObserverService,
    private localStorageService: LocalStorageService,
    private cookieManagerService: CookieManagerService,
    private subscriptionInfoService: SubscriptionInfoService,
    private loginRedirectService: LoginRedirectService

  ) { }

  ngOnInit() {

    this.customObserverService.setItemId$.subscribe(id => {
      if (id == this.id) {
        this.removeFromLocalStorage(id);
      }
    });
    this.paperSet.buttonStatus = this.shoppingCartService.changeButtonIcon(this.id);
    this.paperSet.buyButtonColor = this.shoppingCartService.changeButtonColor(this.id);
    this.customObserverService.currentPaymentType$.subscribe(value => {
      this.currentPaymentType = value;
    });
    this.currentPaymentType = this.localStorageService.get(CookieNames.PaymentModel) ? this.localStorageService.get(CookieNames.PaymentModel).toString() : '';
  }

  fireButton(paperSet) {
    this.cartItemsIDArray = this.shoppingCartService.getItemsIDArray();
    if (this.cartItemsIDArray.indexOf(paperSet._id) !== -1) {
      this.removeFromLocalStorage(paperSet._id);
    }
    else {
      this.addToLocalStorage(paperSet);
      if (this.cartItemsIDArray.length <= 1) {
        $("#mypaymentModal").modal('show');
      }
    }
  }

  livePaperForDialogSubscribers(paperSet) {
    // this.cartItemsIDArray = this.shoppingCartService.getItemsIDArray();
    // if (this.cartItemsIDArray.indexOf(paperSet._id) !== -1) {
    //   this.removeFromLocalStorage(paperSet._id);
    // }
    // else {
    this.addToLocalStorage(paperSet);
    // }
    // this.router.navigate(['home/pay/checkout']);

    this.buyOnlinePaper(paperSet);

  }

  addToLocalStorage(paperSet) {
    this.shoppingCartService.storeItemsCheckout(paperSet);
    this.click = true;
    this.paperSet.buttonStatus = this.shoppingCartService.changeButtonIcon(paperSet._id);
    this.paperSet.buyButtonColor = this.shoppingCartService.changeButtonColor(paperSet._id);
    this.cartItemsIDArray = this.shoppingCartService.getItemsIDArray();
  }

  removeFromLocalStorage(paperSet_id) {
    this.shoppingCartService.removeItemsCheckout(paperSet_id);
    this.click = false;
    this.paperSet.buttonStatus = this.shoppingCartService.changeButtonIcon(paperSet_id);
    this.paperSet.buyButtonColor = this.shoppingCartService.changeButtonColor(paperSet_id);
    this.cartItemsIDArray = this.shoppingCartService.getItemsIDArray();
  }

  /**
   * kauhsalya
   * 2017-10-18
   * get cart details
   */
  getcartDetails() {
    $("#mypaymentModal").modal('hide');;
    // this.router.navigate(['home/pay/checkout/']);
  }

  checkSubscription() {
    $("#packages-pop").modal('show');
  }

  showLoginPopup() {
    let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);
    if (!userObj) {
      $('#log-in-pop').modal('show');
    }
  }

  buyOnlinePaper(paperSet) {
    // $('#onlineExamPaymentConfirmationPopup').modal('show');

    this.loginRedirectService.setRedirectPoint(redirectionPoints.online);

    // this.subscriptionInfoService.selectPackage();
    // this.router.navigate(['home/dialog-subscription-info/onetime']);
    this.router.navigate(['home/dialog-subscription-info/onetime']);


  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/add-cart/components/add-cart.component.ts